export const contactsData = {
    email: 'developer.muhammadabdullah@gmail.com',
    phone: '+92 335 663 5222 ',
    address: 'Islamabad, Pakistan - 46000 ',
    sheetAPI: 'https://script.google.com/macros/s/AKfycbwD73crfttuFpGuLSqrP0eWm_ACu15MfHpSV4CLAwmId95KuilZhCwWQfwLzwwjR_qxcQ/exec'
}